import React from 'react';
import { includes, isEmpty, toLower } from 'lodash';
import InsightsCards from './InsightsCards';
import { CardsContainer } from './styles/InsightsCards.styled';
import LoadMoreGenericBtn from './LoadMoreGenericBtn';
import InsightsContext from '../context/InsightsContext';
import NotFoundSearchMsg from './NotFoundSearchMsg';
import { dateToNum } from '../helpers/date-convert';

export default function InsightsPaginatedCards({ data, dir }) {
  const { filtersArray } = React.useContext(InsightsContext);
  const [filteredData, setFilteredData] = React.useState(data);
  const [loadMore, setLoadMore] = React.useState(false);
  const [hasMore, setHasMore] = React.useState(filteredData.length > 12);
  const [insights, setInsights] = React.useState(
    filteredData.length <= 12 ? filteredData : [...filteredData.slice(0, 12)],
  );

  const optionValues = ['Most Recent', 'Most Popular', 'Trending Topics', 'Business Hub'];

  const handleLoadMore = () => setLoadMore(true);

  React.useEffect(() => {
    if (loadMore && hasMore) {
      const currentLength = +insights.length;
      const isGrater = +currentLength < +filteredData.length;
      const nextResults = isGrater ? filteredData.slice(+currentLength, +currentLength + 12) : [];
      setInsights([...insights, ...nextResults]);
      setLoadMore(false);
    }
  }, [loadMore, hasMore]);

  React.useEffect(() => {
    let filteredArray = [];
    filteredArray = data.filter((value) => includes(value.tags, filtersArray[0]));
    if (includes(optionValues, filtersArray[0])) {
      if (filtersArray[0] === 'Most Recent') {
        filteredArray = [...data].sort(
          (a, b) => dateToNum(b.articleDate) - dateToNum(a.articleDate),
        );
      } else {
        filteredArray = data.filter((value) => includes(value.filters, filtersArray[0]));
      }
    }
    if (!filtersArray[0]) {
      filteredArray = [...data].sort((a, b) => dateToNum(b.articleDate) - dateToNum(a.articleDate));
    }

    if (filtersArray[1] && filtersArray[1] !== 'By Industry') {
      filteredArray = filteredArray.filter((value) =>
        value.industries.some((industry) => industry === filtersArray[1]),
      );
    }
    if (filtersArray[2]) {
      filteredArray = data.filter((value) => includes(value.tags, filtersArray[2]));
    }
    if (filtersArray[3]) {
      filteredArray = data.filter(({ title }) =>
        includes(toLower(title), toLower(filtersArray[3])),
      );
    }
    setFilteredData(filteredArray);
  }, [filtersArray]);

  React.useEffect(() => {
    setInsights(filteredData.length <= 12 ? filteredData : [...filteredData.slice(0, 12)]);
  }, [filteredData]);

  React.useEffect(() => {
    const isGrater = insights.length < filteredData.length;
    setHasMore(isGrater);
  }, [insights]);

  return (
    <>
      <CardsContainer>
        {isEmpty(insights) ? (
          <NotFoundSearchMsg dir={dir} />
        ) : (
          insights.map((card) => <InsightsCards data={card} />)
        )}
      </CardsContainer>
      {hasMore && (
        <LoadMoreGenericBtn
          color="blue"
          position="center"
          label="Load More"
          onClick={handleLoadMore}
        />
      )}
    </>
  );
}
